import { RETIREMENT_CALCULATOR_FORM_SET_VALUE} from "../../../actions/retirementCalculator/retirementCalculatorForm"
import {retirementCalculatorFieldTracking} from "./retirementCalculatorForm"

export const retirementCalculatorTracking = (store, next, action) => {
    if (action.type.startsWith(RETIREMENT_CALCULATOR_FORM_SET_VALUE))
    return retirementCalculatorFieldTracking(store, next, action);

    return null;
};
